import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Map, ArrowLeft } from 'lucide-react';
import { reachConfigAPI, ReachEngagementConfig } from '../../services/reachService';
import { ConfigGate } from '../../components/reach/common/ConfigGate';
import { StakeholderMap } from '../../components/reach/stakeholder-map/StakeholderMap';

const StakeholderMapPage: React.FC = () => {
  const { projectId } = useParams<{ projectId: string }>();
  const navigate = useNavigate();
  const [config, setConfig] = useState<ReachEngagementConfig | null | undefined>(undefined);

  useEffect(() => {
    reachConfigAPI.get(projectId!)
      .then(r => setConfig(r.data.config))
      .catch(() => setConfig(null));
  }, [projectId]);

  if (config === undefined) return (
    <div className="flex items-center justify-center h-64 text-slate-400 font-display">Loading…</div>
  );

  return (
    <div className="flex-1 overflow-y-auto p-8 font-display">
      <div className="w-full max-w-[1400px] mx-auto flex flex-col gap-6">
        <header className="flex items-center gap-4 border-b border-slate-200 pb-6">
          <button onClick={() => navigate(`/projects/${projectId}/reach`)} className="text-slate-400 hover:text-navy transition-colors">
            <ArrowLeft size={20} />
          </button>
          <div className="flex items-center justify-center w-10 h-10 rounded-full bg-primary/10 text-primary">
            <Map size={22} />
          </div>
          <div>
            <h1 className="text-2xl font-bold tracking-tight text-navy">Stakeholder Map</h1>
            <p className="text-slate-500 text-sm font-medium">Influence × readiness — drag stakeholders to position them.</p>
          </div>
        </header>
        <ConfigGate hasConfig={!!config}>
          <StakeholderMap projectId={projectId!} />
        </ConfigGate>
      </div>
    </div>
  );
};

export default StakeholderMapPage;
